import Services from "../Services";

const canBadge = (clear = false) => {
  const {isExtension, isInjected} = Services;

  if (!isExtension || (!clear && !isInjected)) {
    return false;
  }

  return true;
};

class Manager {
  clearBadge() {
    if (!canBadge(true)) {
      return;
    }

    window.browser.runtime.sendMessage({action: "clearBadge"});
  }

  incrementBadge() {
    if (!canBadge()) {
      return;
    }

    window.browser.runtime.sendMessage({action: "incrementBadge"});
  }

  setBadge(options = {}) {
    if (!canBadge()) {
      return;
    }

    const {text, backgroundColor = "#105270"} = options;

    window.browser.runtime.sendMessage({
      action: "setBadge",
      text,
      backgroundColor
    });
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonExtensionManager) {
    window.atsSecurityRibbonExtensionManager = new Manager();
  }
  return window.atsSecurityRibbonExtensionManager;
};

export default Configuration();

export const ManagerClass = Manager;
